import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbilityServiceSignal } from '@casl/angular';
import { TranslatePipe } from '@ngx-translate/core';
import {
  QualificationTrainings,
  QualificationTrainingsStatus,
  RoleAction,
  RolePermissionSubject,
} from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { map, Observable, Subject, takeUntil, tap } from 'rxjs';
import { TrainingQualificationsV2ListService } from '../../../service/training-qualifications-v2-list.service';
import { TrainingQualificationsBulkEditDrawerService } from '../training-qualifications-bulk-edit-drawer/training-qualifications-bulk-edit-drawer.service';

@Component({
  selector: 'wilson-training-qualification-bulk-edit-trigger',
  imports: [CommonModule, TranslatePipe, NzButtonModule, NzTooltipModule],
  templateUrl: './training-qualification-bulk-edit-trigger.component.html',
  styleUrl: './training-qualification-bulk-edit-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingQualificationBulkEditTriggerComponent
  implements OnInit, OnDestroy
{
  private readonly trainingQualificationsV2ListService = inject(
    TrainingQualificationsV2ListService,
  );
  private readonly trainingQualificationsBulkEditDrawerService = inject(
    TrainingQualificationsBulkEditDrawerService,
  );

  private destroyed$ = new Subject<void>();

  @Output() refresh = new EventEmitter<number>();

  public can = inject(AbilityServiceSignal).can;
  public readonly RoleAction = RoleAction;
  public readonly RolePermissionSubject = RolePermissionSubject;

  protected editableQualificationTrainings$!: Observable<
    QualificationTrainings[]
  >;

  ngOnInit() {
    this.editableQualificationTrainings$ =
      this.trainingQualificationsV2ListService.selectedQualificationTrainings$.pipe(
        map((qualificationTrainings) => {
          return this.getEditableTrainings(qualificationTrainings);
        }),
        tap((editableTrainings) => {
          this.trainingQualificationsBulkEditDrawerService.setTrainingsToEdit(
            editableTrainings,
          );
        }),
      );
    this.trainingQualificationsBulkEditDrawerService.bulkEditedTrainings$
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => {
          this.refresh.emit(new Date().getTime());
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private getEditableTrainings(
    qualificationTrainings: QualificationTrainings[],
  ): QualificationTrainings[] {
    return qualificationTrainings.filter((qualificationTraining) => {
      return (
        qualificationTraining.status !==
          QualificationTrainingsStatus.cancelled &&
        qualificationTraining.status !==
          QualificationTrainingsStatus.qualificationCreated
      );
    });
  }

  protected showTrainingQualificationBulkEditDrawer(): void {
    this.trainingQualificationsBulkEditDrawerService.setBulkEditDrawerVisible(
      true,
    );
  }
}
